import { createContext, SyntheticEvent } from 'react'
import { IGif } from '@giphy/js-types'

const noop = (...args) => console.log(...args)

export type GAEVentContextProps = {
    onGifClick: (gif: IGif, e: SyntheticEvent<HTMLElement, Event>) => void
    onGifRightClick: (gif: IGif, e: SyntheticEvent<HTMLElement, Event>) => void
    onAttributionHold: (gif: IGif) => void
    onAttributionClick: (gif: IGif) => void
    onStickerAttributionChannelClick: (gif: IGif) => void
    onGifFavorite: (gif: IGif) => void
    onLinkCopy: (gif: IGif) => void
    onPagination: (page: number) => void
}

const GAEventContext = createContext({
    onGifClick: noop,
    onGifRightClick: noop,
    onAttributionHold: noop,
    onAttributionClick: noop,
    onStickerAttributionChannelClick: noop,
    onGifFavorite: noop,
    onLinkCopy: noop,
} as GAEVentContextProps)

export default GAEventContext
